import { fmtTL, fmtCur } from "@/components/StatusBadge";
import { QRCodeSVG } from "qrcode.react";
import { verifyUrl, surveyUrl, logoUrl, docImageUrl, docStampUrl, docStampPos, activeDocTheme, activeDocTemplate, docBrandName, docShowBrandText, docLegalName, docAddress, docTaxLine, docWeb, docSlogan, docCfg } from "@/lib/company";

const METHOD_LABEL = { cash: "Nakit", card: "Kredi/Banka Kartı" };

const dt = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

function SaleBody({ sale, cashier, cfg }) {
  const lines = sale.lines || [];
  const tenders = (sale.payment?.tenders) || [];
  const disc = (sale.discount || 0);
  const ref = sale.edoc?.doc_no || sale.sale_no || "";
  const showBrand = cfg.show_brand && docShowBrandText();
  return (
    <>
      {cfg.show_logo && <div className="t-center"><img className="t-logoimg" src={logoUrl()} alt={docBrandName()} /></div>}
      {showBrand && <div className="t-center t-bold" style={{ fontSize: "14px", letterSpacing: "1px" }}>{docBrandName()}</div>}
      {cfg.stamp && docStampPos() === "top" && (
        <div style={{ marginTop: "4px", textAlign: "center" }} data-testid="receipt-stamp-top">
          {docStampUrl()
            ? <img src={docImageUrl(docStampUrl())} alt="Kaşe & İmza" data-testid="receipt-stamp-img" style={{ display: "inline-block", maxHeight: "58px", maxWidth: "130px" }} />
            : <span data-testid="receipt-stamp-text" style={{ display: "inline-block", transform: "rotate(-4deg)", border: "1.5px solid #000", borderRadius: "6px", padding: "4px 12px", lineHeight: 1.25, textAlign: "center" }}>
                <span className="t-bold" style={{ fontSize: "11px", letterSpacing: "1.5px", display: "block" }}>RESMÎ BELGE</span>
                <span className="t-cap" style={{ fontSize: "8px" }}>{docBrandName()}</span>
              </span>}
        </div>
      )}
      <div className="t-accent" />
      {docSlogan() && <div className="t-tag">{docSlogan()}</div>}
      <div className="t-center t-sm t-bold">{docLegalName()}</div>
      <div className="t-center t-sm">{docAddress()}</div>
      <div className="t-center t-sm">{docTaxLine()}</div>
      {cfg.header_lines.map((l, i) => <div key={i} className="t-center t-sm" data-testid="receipt-header-line">{l}</div>)}
      {sale.location_name && <div className="t-center t-sm">{sale.location_name}</div>}
      <div className="t-center t-sm t-bold" style={{ marginTop: "3px" }}>{cfg.title || (sale.customer_name ? "BİLGİ FİŞİ" : "SATIŞ FİŞİ")}</div>
      {sale.customer_name && (
        <div className="t-center t-cap" data-testid="receipt-info-note" style={{ marginTop: "2px", fontWeight: 700 }}>
          BİLGİLENDİRME AMAÇLIDIR · MALİ DEĞERİ YOKTUR{sale.edoc ? ` · RESMİ BELGE: ${sale.edoc.doc_type_label}` : " · FATURA DÜZENLENECEKTİR"}
        </div>
      )}
      <div className="t-hr" />
      <div className="t-row t-sm"><span>Fiş No</span><span>{sale.sale_no}</span></div>
      {sale.edoc && <div className="t-row t-sm"><span>{sale.edoc.doc_type_label} No</span><span>{sale.edoc.doc_no}</span></div>}
      <div className="t-row t-sm"><span>Tarih</span><span>{dt(sale.created_at)}</span></div>
      {cashier && <div className="t-row t-sm"><span>Kasiyer</span><span>{cashier}</span></div>}
      {sale.customer_name && <div className="t-row t-sm"><span>Müşteri</span><span>{sale.customer_name}</span></div>}
      <div className="t-hr" />
      {lines.map((l, i) => (
        <div key={i} style={{ marginBottom: "2px" }}>
          <div className="t-name">{l.name}</div>
          <div className="t-row">
            <span>{l.quantity} x {fmtTL(l.unit_price)}{l.vat_rate != null ? `  (KDV %${l.vat_rate})` : ""}</span>
            <span className="t-bold">{fmtTL(l.line_total)}</span>
          </div>
        </div>
      ))}
      <div className="t-hr" />
      <div className="t-row"><span>Ara Toplam (KDV hariç)</span><span>{fmtTL(sale.subtotal)}</span></div>
      <div className="t-row"><span>KDV</span><span>{fmtTL(sale.vat_total)}</span></div>
      {disc > 0 && <div className="t-row"><span>İndirim</span><span>-{fmtTL(disc)}</span></div>}
      {(sale.campaigns_applied || []).length > 0 && <div className="t-row t-sm"><span>↳ Kampanya: {(sale.campaigns_applied).map((c) => c.name).join(", ")}</span><span>-{fmtTL((sale.campaigns_applied).reduce((s, c) => s + (c.discount || 0), 0))}</span></div>}
      {sale.loyalty_redeem > 0 && <div className="t-row t-sm"><span>↳ Puan kullanımı ({sale.loyalty_points_used}p)</span><span>-{fmtTL(sale.loyalty_redeem)}</span></div>}
      {sale.meal_card_surcharge > 0 && <div className="t-row"><span>Yemek Kartı Kom.{sale.meal_card_provider ? ` (${sale.meal_card_provider})` : ""}</span><span>+{fmtTL(sale.meal_card_surcharge)}</span></div>}
      <div className="t-total-box"><span>TOPLAM</span><span>{fmtTL(sale.total)}</span></div>
      {(sale.loyalty_earned > 0 || sale.loyalty_used > 0) && (
        <div className="t-row t-sm" style={{ marginTop: "2px" }}><span>★ Puan{sale.loyalty_earned > 0 ? ` +${sale.loyalty_earned}` : ""}{sale.loyalty_used > 0 ? ` -${sale.loyalty_used}` : ""}</span><span>{sale.loyalty_balance != null ? `Bakiye: ${sale.loyalty_balance}` : ""}</span></div>
      )}
      <div className="t-hr" />
      <div className="t-sm t-bold">ÖDEME</div>
      {tenders.map((t, i) => (
        <div key={i} className="t-row t-sm">
          <span>{METHOD_LABEL[t.method] || t.method}{t.currency && t.currency !== "TRY" ? ` (${fmtCur(t.amount, t.currency)})` : ""}</span>
          <span>{fmtTL(t.amount_try != null ? t.amount_try : t.amount)}</span>
        </div>
      ))}
      {sale.change_try > 0 && <div className="t-row t-sm"><span>Para Üstü</span><span>{fmtTL(sale.change_try)}</span></div>}
      {sale.public_day_active && (
        <>
          <div className="t-hr" />
          <div className="t-center t-bold" data-testid="receipt-public-day">★ HALK GÜNÜ FIRSATI ★</div>
        </>
      )}
      {(cfg.qr_verify || cfg.qr_survey) && (
        <>
          <div className="t-hr" />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", gap: "14px", margin: "6px 2px" }}>
            {cfg.qr_verify && (
              <div style={{ textAlign: "center", flex: "0 0 auto" }}>
                <QRCodeSVG value={verifyUrl(ref)} size={86} level="M" />
                <div className="t-cap" style={{ marginTop: "2px" }}>Fiş Doğrula</div>
              </div>
            )}
            {cfg.qr_survey && (
              <div style={{ textAlign: "center", flex: "0 0 auto" }}>
                <QRCodeSVG value={surveyUrl(ref)} size={86} level="M" />
                <div className="t-cap" style={{ marginTop: "2px" }}>Değerlendir / Anket</div>
              </div>
            )}
          </div>
        </>
      )}
      <div className="t-center t-sm">{docWeb()} · {ref}</div>
      <div className="t-hr" />
      {cfg.footer_lines.map((l, i) => <div key={i} className="t-center t-sm" data-testid="receipt-footer-line">{l}</div>)}
      {cfg.stamp && docStampPos() !== "top" && (
        <div style={{ marginTop: "6px", textAlign: docStampPos() }} data-testid="receipt-stamp">
          {docStampUrl()
            ? <img src={docImageUrl(docStampUrl())} alt="Kaşe & İmza" data-testid="receipt-stamp-img" style={{ display: "inline-block", maxHeight: "58px", maxWidth: "130px" }} />
            : <span data-testid="receipt-stamp-text" style={{ display: "inline-block", transform: "rotate(-4deg)", border: "1.5px solid #000", borderRadius: "6px", padding: "4px 12px", lineHeight: 1.25, textAlign: "center" }}>
                <span className="t-bold" style={{ fontSize: "11px", letterSpacing: "1.5px", display: "block" }}>RESMÎ BELGE</span>
                <span className="t-cap" style={{ fontSize: "8px" }}>{docBrandName()}</span>
              </span>}
        </div>
      )}
      {showBrand && <div className="t-center t-sm">{docBrandName()}</div>}
    </>
  );
}

function ZBody({ report, cfg }) {
  const bc = report.by_currency || [];
  const fmtAmt = (n) => Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const curLabel = (c) => (c === "TRY" ? "TL" : c);
  const showBrand = cfg.show_brand && docShowBrandText();
  return (
    <>
      {cfg.show_logo && <div className="t-center"><img className="t-logoimg" src={logoUrl()} alt={docBrandName()} /></div>}
      {showBrand && <div className="t-center t-bold" style={{ fontSize: "13px" }}>{docBrandName()}</div>}
      <div className="t-accent" />
      <div className="t-center t-sm t-bold">{docBrandName()}</div>
      <div className="t-center t-sm">KASA KAPANIŞ (Z) RAPORU</div>
      <div className="t-hr" />
      {report.register_name && <div className="t-row t-sm"><span>Kasa</span><span>{report.register_code ? `${report.register_code} · ` : ""}{report.register_name}</span></div>}
      {report.cashier_name && <div className="t-row t-sm"><span>Kasiyer</span><span>{report.cashier_name}</span></div>}
      {report.operator_name && <div className="t-row t-sm"><span>Personel (Vardiya)</span><span>{report.operator_staff_code ? `${report.operator_name} · ${report.operator_staff_code}` : report.operator_name}</span></div>}
      <div className="t-row t-sm"><span>Açılış</span><span>{dt(report.opened_at)}</span></div>
      <div className="t-row t-sm"><span>Kapanış</span><span>{dt(report.closed_at)}</span></div>
      <div className="t-hr" />
      <div className="t-row"><span>Açılış (devir)</span><span>{fmtTL(report.opening_amount)}</span></div>
      <div className="t-row"><span>Satış Adedi</span><span>{report.sales_count}</span></div>
      <div className="t-row"><span>Toplam Satış</span><span>{fmtTL(report.grand_total)}</span></div>
      {report.refund_count > 0 && <div className="t-row"><span>İade Adedi</span><span>{report.refund_count}</span></div>}
      {report.refund_total > 0 && <div className="t-row"><span>İade Tutarı</span><span>-{fmtTL(report.refund_total)}</span></div>}
      <div className="t-row"><span>Nakit</span><span>{fmtTL(report.cash_total)}</span></div>
      <div className="t-row"><span>Kredi Kartı</span><span>{fmtTL(report.card_total)}</span></div>
      <div className="t-row"><span>Verilen İndirim</span><span>-{fmtTL(report.discount_total)}</span></div>
      <div className="t-hr" />
      <div className="t-row t-lg"><span>KASADA OLMASI GEREKEN</span><span>{fmtTL(report.expected_drawer)}</span></div>
      {report.counted_cash != null && <div className="t-row"><span>Sayılan Nakit (kapanış)</span><span>{fmtTL(report.counted_cash)}</span></div>}
      {report.over_short != null && (
        <div className="t-row t-bold">
          <span>{report.over_short < 0 ? "KASA AÇIĞI" : report.over_short > 0 ? "KASA FAZLASI" : "KASA FARKI"}</span>
          <span>{report.over_short < 0 ? "-" : report.over_short > 0 ? "+" : ""}{fmtTL(Math.abs(report.over_short))}</span>
        </div>
      )}
      {report.reward_enabled && (
        <div className="t-row t-bold"><span>ÖDÜL PUANI (Kasiyer)</span><span>{report.reward_earned ? `★ +${report.reward_points}` : "—"}</span></div>
      )}
      {bc.length > 0 && (
        <>
          <div className="t-hr" />
          <div className="t-sm t-bold">ÖDEME PARA BİRİMLERİ</div>
          {bc.map((c) => (
            <div key={c.currency} className="t-row t-sm"><span>{curLabel(c.currency)} ({c.count})</span><span>{fmtAmt(c.total)} {curLabel(c.currency)}{c.currency !== "TRY" ? ` ≈ ${fmtTL(c.total_try)}` : ""}</span></div>
          ))}
        </>
      )}
      <div className="t-hr" />
      <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", margin: "18px 2px 4px" }}>
        <div style={{ flex: 1, textAlign: "center", borderTop: "1px solid #000", paddingTop: "3px" }}>
          <div className="t-sm t-bold">Kasiyer</div>
          <div className="t-cap">{report.cashier_name || ""}</div>
        </div>
        <div style={{ flex: 1, textAlign: "center", borderTop: "1px solid #000", paddingTop: "3px" }}>
          <div className="t-sm t-bold">Onaylayan Amir</div>
          <div className="t-cap">{report.self_close ? "Kasiyer (kendi)" : (report.approver_name || report.approved_by || "")}</div>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", margin: "10px 0 6px" }}>
        <QRCodeSVG value={`GROOT-Z|${report.shift_no || report.shift_id || ""}|${report.closed_at || report.generated_at || ""}|B:${report.expected_drawer}|S:${report.counted_cash}|F:${report.over_short}`} size={64} level="M" />
        <div style={{ border: "1.5px solid #000", borderRadius: "6px", padding: "6px 12px", textAlign: "center", transform: "rotate(-4deg)" }}>
          <div className="t-bold" style={{ fontSize: "12px", letterSpacing: "1.5px" }}>ONAYLANDI</div>
          <div className="t-cap" style={{ fontSize: "9px" }}>{docBrandName()}</div>
          <div style={{ fontSize: "9px" }}>{dt(report.closed_at || report.generated_at)}</div>
        </div>
      </div>
      <div className="t-hr" />
      {showBrand && <div className="t-center t-sm">{docBrandName()}</div>}
    </>
  );
}

function RefundBody({ sale, cashier, cfg }) {
  const lines = sale.lines || [];
  const amt = Math.abs(Number(sale.total || 0));
  const alloc = sale.allocation || {
    cash: Math.abs(Number(sale.cash_try || 0)),
    card: Math.abs(Number(sale.card_try || 0)),
    qr: Math.abs(Number(sale.qr_try || 0)),
  };
  const showBrand = cfg.show_brand && docShowBrandText();
  return (
    <>
      {cfg.show_logo && <div className="t-center"><img className="t-logoimg" src={logoUrl()} alt={docBrandName()} /></div>}
      {showBrand && <div className="t-center t-bold" style={{ fontSize: "14px", letterSpacing: "1px" }}>{docBrandName()}</div>}
      <div className="t-accent" />
      {docSlogan() && <div className="t-tag">{docSlogan()}</div>}
      <div className="t-center t-sm t-bold">{docLegalName()}</div>
      <div className="t-center t-sm">{docAddress()}</div>
      <div className="t-center t-sm">{docTaxLine()}</div>
      {sale.location_name && <div className="t-center t-sm">{sale.location_name}</div>}
      <div className="t-center t-bold" style={{ marginTop: "4px", fontSize: "14px", letterSpacing: "1px" }} data-testid="refund-receipt-title">İADE FİŞİ</div>
      <div className="t-center t-cap" style={{ fontWeight: 700 }}>MÜŞTERİYE İADE · MALİ DEĞERİ YOKTUR</div>
      <div className="t-hr" />
      <div className="t-row t-sm"><span>İade Fiş No</span><span>{sale.sale_no}</span></div>
      {sale.refund_of_no && <div className="t-row t-sm"><span>Orijinal Fiş</span><span>{sale.refund_of_no}</span></div>}
      <div className="t-row t-sm"><span>Tarih</span><span>{dt(sale.created_at)}</span></div>
      {cashier && <div className="t-row t-sm"><span>İşlemi Yapan</span><span>{cashier}</span></div>}
      {sale.customer_name && <div className="t-row t-sm"><span>Müşteri</span><span>{sale.customer_name}</span></div>}
      <div className="t-hr" />
      {lines.map((l, i) => {
        const q = Math.abs(Number(l.quantity || 0));
        return (
          <div key={i} style={{ marginBottom: "2px" }}>
            <div className="t-name">{l.name}</div>
            <div className="t-row">
              <span>{q} x {fmtTL(l.unit_price)}{l.vat_rate != null ? `  (KDV %${l.vat_rate})` : ""}</span>
              <span className="t-bold">-{fmtTL(q * Number(l.unit_price || 0))}</span>
            </div>
          </div>
        );
      })}
      <div className="t-total-box"><span>İADE TOPLAMI</span><span>-{fmtTL(amt)}</span></div>
      <div className="t-hr" />
      <div className="t-sm t-bold">İADE YÖNTEMİ</div>
      {alloc.card > 0 && <div className="t-row t-sm"><span>Kart / Banka Kartına İade</span><span>-{fmtTL(alloc.card)}</span></div>}
      {alloc.qr > 0 && <div className="t-row t-sm"><span>QR / Mobil İade</span><span>-{fmtTL(alloc.qr)}</span></div>}
      {alloc.cash > 0 && <div className="t-row t-sm"><span>Nakit İade</span><span>-{fmtTL(alloc.cash)}</span></div>}
      <div className="t-hr" />
      <div className="t-center t-sm">{docWeb()} · {sale.sale_no}</div>
      <div className="t-hr" />
      {cfg.footer_lines.map((l, i) => <div key={i} className="t-center t-sm">{l}</div>)}
      {showBrand && <div className="t-center t-sm">{docBrandName()}</div>}
    </>
  );
}

export const THERMAL_PREVIEW_CSS = `
  #thermal-root { font-family:'JetBrains Mono',monospace; color:#000; font-size:12px; line-height:1.35; width:76mm; margin:0 auto; padding:2mm 3mm; }
  #thermal-root .t-center { text-align:center; }
  #thermal-root .t-row { display:flex; justify-content:space-between; gap:6px; }
  #thermal-root .t-hr { border-top:1px dashed #000; margin:4px 0; }
  #thermal-root .t-lg { font-size:15px; font-weight:700; }
  #thermal-root .t-sm { font-size:10px; }
  #thermal-root .t-bold { font-weight:700; }
  #thermal-root .t-name { flex:1; word-break:break-word; }
  #thermal-root .t-cap { text-align:center; font-size:9px; letter-spacing:.5px; margin-bottom:2px; }
  #thermal-root .t-logoimg { display:block; margin:0 auto 3px; max-height:46px; width:auto; filter:grayscale(1) contrast(1.2); }
  #thermal-root .t-tag { text-align:center; font-size:9px; letter-spacing:2px; text-transform:uppercase; font-weight:700; margin-bottom:2px; }
  #thermal-root .t-total-box { border:2px solid #000; border-radius:6px; padding:5px 9px; margin:5px 0; display:flex; justify-content:space-between; align-items:center; font-size:16px; font-weight:800; }
  #thermal-root .t-accent { border-top:3px solid var(--rc-accent,#EA580C); width:60%; margin:5px auto 4px; }
  #thermal-root svg { display:inline-block; }
  /* ---- Şablon varyantları (80mm; klasik = varsayılan) ---- */
  #thermal-root[data-template="modern"] .t-total-box { border-width:3px; }
  #thermal-root[data-template="modern"] .t-accent { border-top-width:5px; width:80%; }
  #thermal-root[data-template="minimal"] .t-accent { display:none; }
  #thermal-root[data-template="minimal"] .t-total-box { border:0; border-top:2px solid #000; border-bottom:2px solid #000; border-radius:0; }
  #thermal-root[data-template="zarif"] { font-family:'Georgia','Times New Roman',serif; }
  #thermal-root[data-template="zarif"] .t-tag { letter-spacing:3px; }
  #thermal-root[data-template="kompakt"] { font-size:11px; line-height:1.25; }
  #thermal-root[data-template="kompakt"] .t-sm { font-size:9px; }
  #thermal-root[data-template="kompakt"] .t-hr { margin:2px 0; }
  #thermal-root[data-template="ferah"] { line-height:1.6; }
  #thermal-root[data-template="ferah"] .t-hr { margin:7px 0; }
  #thermal-root[data-template="kutu"] .t-total-box { border-radius:0; }
  #thermal-root[data-template="kurumsal"] .t-accent { border-top-style:double; border-top-width:4px; }
  #thermal-root[data-template="premium"] .t-accent { width:100%; border-top-width:4px; }
`;

export function ThermalDoc({ doc, docConfig }) {
  if (!doc) return null;
  const cfg = docConfig || docCfg("receipt");
  return (
    <div id="thermal-root" data-testid="thermal-root" data-template={activeDocTemplate()} style={{ "--rc-accent": activeDocTheme().accent }}>
      {doc.type === "z" ? <ZBody report={doc.report} cfg={cfg} /> : doc.type === "refund" ? <RefundBody sale={doc.sale} cashier={doc.cashier} cfg={cfg} /> : <SaleBody sale={doc.sale} cashier={doc.cashier} cfg={cfg} />}
    </div>
  );
}
